import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  missingDocumentList: object;
  missingUploadDocumentResponse: object;
}

const initialState: AuthState = {
  missingDocumentList: {},
  missingUploadDocumentResponse: {}
};

const orgSlice = createSlice({
  name: 'MissingDocumentList',
  initialState,
  reducers: {
    setMissingDocumentList: (state, action: PayloadAction<object>) => {
      state.missingDocumentList = action.payload;
    },
    clearMissingDocumentList: state => {
      state.missingDocumentList = {};
    },
    setMissingUploadDocumentResponse: (state, action: PayloadAction<object>) => {
      state.missingUploadDocumentResponse = action.payload;
    },
    clearMissingUploadDocumentResponse: state => {
      state.missingUploadDocumentResponse = {};
    },
  },
});

export const { setMissingDocumentList, clearMissingDocumentList, setMissingUploadDocumentResponse, clearMissingUploadDocumentResponse } = orgSlice.actions;
export default orgSlice.reducer;
